module.exports = __webpack_public_path__ + "img/roomStatus.f2c8ccd2.svg";